<div class="page-breadcrumb" *ngIf="write==true || read==true  ">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">Page Content Management</h4>
        </div>

    </div>
</div>

<!-- <div style="display: block;Width:13%;margin-left: 30px;margin-top:-22px;" *ngIf="write==true">
    <li class="mt-3">
        <a *ngIf="!show" href="javascript:void(0)" (click)="addPageContent()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Add </span>
        </a>
        <a *ngIf="show" href="javascript:void(0)" (click)="addPageContent()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Remove </span>
        </a>
    </li>
</div> -->
<!-- ============================================================== -->


<div *ngIf="show">
    <div style="margin-top:-22px;">

        <div class="container-fluid">
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <div class="row">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <form #pageContent="ngForm" novalidate>
                                <div class="form-body">
                                    <h5 class="card-title"> Page Content Management</h5>
                                    <hr>

                                    <div class="row">
                                        <div class="col-md-6 ">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Page
                                                    Name</label>
                                                <input type="text" id="screenName" required #screenName="ngModel"
                                                    onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)"
                                                    name="screenname" placeholder="Screen Name" class="form-control"
                                                    [(ngModel)]="pageContentAddObj.screenName" minlength="3"
                                                    maxlength="30" pattern="^[^\d\W]+( [^\d\W]+)*$">
                                                <span class="text-danger" [hidden]="!screenName.errors.required"
                                                    *ngIf="screenName.errors && (screenName.touched || screenName.dirty)">*This
                                                    Field is Required
                                                </span>
                                                <span class="text-danger" [hidden]="!screenName.errors?.pattern"
                                                    *ngIf="screenName.errors && (screenName.touched || screenName.dirty)">
                                                    First Name Should Start With Alphabets</span>
                                                <span class="text-danger"
                                                    [hidden]="!screenName.errors?.minlength || screenName.errors.pattern"
                                                    *ngIf="screenName.errors && (screenName.touched || screenName.dirty)">First
                                                    Name Should Be Min 3 Characters</span>
                                            </div>
                                        </div>
                                        <!--/span-->
                                        <div class="col-md-6 ">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Page
                                                    Id</label>
                                                <input type="tel" name="screenid" placeholder="Screen Id"
                                                    class="form-control" id="screenid" required
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                    #screenid="ngModel" [(ngModel)]="pageContentAddObj.screenId">
                                                <span class="text-danger" [hidden]="!screenid.errors.required"
                                                    *ngIf="screenid.errors && (screenid.touched || screenid.dirty)">*This
                                                    Field is Required
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                   <!--/row-->
                        <label class="control-label"> <span class="text-danger">*</span> Title</label>
                        <div class="row">
                            <div class="col-md-12 ">
                                <div class="form-group">
                                    <input type="text" id="title" required #title="ngModel" name="title"
                                        [(ngModel)]="pageContentAddObj.title" class="form-control" rows="4">
                                    <span style="font-size: small" class="text-danger" [hidden]="!title.errors.required"
                                        *ngIf="title.errors && (title.touched || title.dirty)">
                                        This Field is Required</span>
                                </div>
                            </div>
                        </div>
                                    <label class="control-label"> <span class="text-danger">*</span> Page Content
                                        File</label>
                                    <div class="row">
                                        <div class="col-md-12 ">
                                            <div class="form-group">
                                                <!-- <textarea class="form-control" id="notificationTextDescripition" required #notificationTextDescripition="ngModel"
                                                    name="notificationTextDescripition" [(ngModel)]="pageContentAddObj.text" rows="4"></textarea>
                                                    <span style="font-size: small" class="text-danger"
                                                    [hidden]="!notificationTextDescripition.errors.required"
                                                    *ngIf="notificationTextDescripition.errors && (notificationTextDescripition.touched || notificationTextDescripition.dirty)">
                                                    This Field is Required</span> -->
                                                <!--
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!text.errors.required"
                                                    *ngIf="text.errors && (text.touched || text.dirty)">
                                                    This Field is Required</span> -->
                                                    <input type="file" required #fileUpload="ngModel" id="syllabus" accept="application/pdf" class="form-control"
                                                    (change)="fileChangeEvent($event)" placeholder="Upload file(only pdf)" name="fileUpload" [(ngModel)]="pageContentAddObj.fileUpload">
                                      
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <br>
                                <div class="form-actions m-t-40">
                                    <button type="submit" style="background-color: #353556;color:white"
                                        [disabled]="!pageContent.valid" class="btn "
                                        (click)="savePageContentManagement()">
                                        <i class="fa fa-check"></i> Submit</button>&nbsp;&nbsp;
                                    <button type="button" class="btn btn-dark" (click)="addPageContent()"
                                        data-dismiss="modal">Cancel</button>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Column -->
            </div>

        </div>

    </div>
</div>
<div class="container-fluid" style="margin-top: 20px" >

    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">

                            <diV class="row">
                                <div class="col-sm-12 col-md-8">
                                </div>
                                
                               
                            </diV>

                            <div>
                                <div>
                                    <mat-form-field>

                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table
                                        [dataSource]="dataSource" matSort style=" margin-top: 30px;">
                                        <ng-container matColumnDef="screenId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Page Id</th>
                                            <td *matCellDef="let row" style="padding-left: 14px;">{{row.screenId}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="screenName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Page Name</th>
                                            <td *matCellDef="let row">{{row.screenName}}</td>
                                        </ng-container>

                                        
                                        <ng-container matColumnDef="text">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Page Content</th>
                                            <td *matCellDef="let row">
                                                <a href="{{myurl+'Misc/Files/pagecontent/'+row.screenName}}" target="_blank" type="button" >  {{row.title}} </a>

                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="dateOfCreation">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
                                            <td *matCellDef="let row"> 
                                               
                                                {{row.dateOfCreation|date}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="dateOfModification">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Modified Date</th>
                                            <td *matCellDef="let row"> 
                                                {{row.dateOfModification|date}}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="Action">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions
                                            </th>
                                            <td *matCellDef="let row;"> 
                                                <p *ngIf="read==true && write !=true && delete !=true" style="color:#353556;font-family: initial;font-weight: 500;">You don't have permissions to Edit/Delete</p>

                                                    <button data-toggle="modal"data-target="#responsive"
                                                    (click)="getPageContentById(row._id)" *ngIf="write==true">  <i class="fa fa-address-card"
                                                    aria-hidden="true"></i>&nbsp;&nbsp;Edit</button>
                                              
                                          
                                            </td>
                                        </ng-container>
                                        

                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>

                        </div>
                    </div>
                    <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25,100]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>

</div>


<div id="responsive" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content bigModel" style="width:900px">
            <div class="modal-header">
                <h4>Edit Email Notification Text Management</h4>
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <form #pageContentUpdate="ngForm" novalidate>
                    <div class="form-body">
                       

                        <div class="row">
                            <div class="col-md-6 ">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Screen Name</label>
                                    <input type="text" id="screenName" readonly required #screenName="ngModel"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)"
                                        name="screenname" placeholder="Screen Name" class="form-control"
                                        [(ngModel)]="pageContentAddObj.screenName" minlength="3" maxlength="30"
                                        pattern="^[^\d\W]+( [^\d\W]+)*$">
                                    <span class="text-danger" [hidden]="!screenName.errors.required"
                                        *ngIf="screenName.errors && (screenName.touched || screenName.dirty)">*This
                                        Field is Required
                                    </span>
                                    <span class="text-danger" [hidden]="!screenName.errors?.pattern"
                                        *ngIf="screenName.errors && (screenName.touched || screenName.dirty)">
                                        First Name Should Start With Alphabets</span>
                                    <span class="text-danger"
                                        [hidden]="!screenName.errors?.minlength || screenName.errors.pattern"
                                        *ngIf="screenName.errors && (screenName.touched || screenName.dirty)">First
                                        Name Should Be Min 3 Characters</span>
                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6 ">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Screen Id</label>
                                    <input type="tel" name="screenid" readonly placeholder="Screen Id" class="form-control"
                                        id="screenid" required
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                        #screenid="ngModel" [(ngModel)]="pageContentAddObj.screenId">
                                    <span class="text-danger" [hidden]="!screenid.errors.required"
                                        *ngIf="screenid.errors && (screenid.touched || screenid.dirty)">*This Field is
                                        Required
                                    </span>
                                </div>
                            </div>
                        </div>
                        <!--/row-->
                        <label class="control-label"> <span class="text-danger">*</span> Title</label>
                        <div class="row">
                            <div class="col-md-12 ">
                                <div class="form-group">
                                    <input type="text" id="title" required #title="ngModel" name="title"
                                        [(ngModel)]="pageContentAddObj.title" class="form-control" rows="4">
                                    <span style="font-size: small" class="text-danger" [hidden]="!title.errors.required"
                                        *ngIf="title.errors && (title.touched || title.dirty)">
                                        This Field is Required</span>
                                </div>
                            </div>
                        </div>
                        <label class="control-label">  Page Content File</label>
                        <div class="row">
                            <div class="col-md-12 ">
                                <div class="form-group">
                                    <!-- <textarea class="form-control" id="notificationTextDescripition" required #notificationTextDescripition="ngModel"
                                        name="notificationTextDescripition" [(ngModel)]="pageContentAddObj.text" rows="4"></textarea>
                                        <span style="font-size: small" class="text-danger"
                                        [hidden]="!notificationTextDescripition.errors.required"
                                        *ngIf="notificationTextDescripition.errors && (notificationTextDescripition.touched || notificationTextDescripition.dirty)">
                                        This Field is Required</span> -->
                                        <input type="file"  #fileUpload="ngModel" id="syllabus" accept="application/pdf" class="form-control"
                                        (change)="fileChangeEvent($event)" placeholder="Upload file(only pdf)" name="fileUpload" [(ngModel)]="pageContentAddObj.fileUpload">
                          

                                </div>
                            </div>
                        </div>

                    </div>
                    <br>
                    <div class="form-actions m-t-40">
                        <button type="submit" style="background-color: #353556;color:white"  data-dismiss="modal"
                            [disabled]="!pageContentUpdate.valid" class="btn " (click)="updatePageContent()">
                            <i class="fa fa-check"></i> Submit</button>&nbsp;&nbsp;
                            <button type="button" class="btn btn-dark" data-dismiss="modal" >Cancel</button>


                    </div>
                </form>
            </div>
        </div>
    </div>
</div>